import React, { useEffect } from "react"
import { Flex, Paper, Text } from "@mantine/core"

import { useStyles } from "@/pages/home/components/UserActionFavoritesAndHistory.styles"
import { Button, Icon } from "@/components"

import constants from "shared/favorites/constants"

// -- migrated from app/static/frontend/favorites/components/FavoriteAndRecentUserActionsViewer -- //

export const UserActionFavoritesAndHistory = (props) => {
    const { classes } = useStyles()
    const { loadUserActions } = props

    useEffect(() => {
        loadUserActions()
    }, [loadUserActions])

    // handler for clicking the overall button
    const onClick = (userAction) => () => {
        const { UserActionType } = DjangIO.app.useractions.types

        if (userAction.action_type === UserActionType.search_created.value) {
            props.segueToSearch({
                quorumDataType: userAction.data_type,
                initialFilter: userAction.safedsearch.filters[0],
            })

            return
        }

        const qdt = DjangIO.app.models.QuorumDataType.by_value(userAction.data_type)
        qdt && props.segueToProfile({ id: userAction[qdt.related_pk_field] }, qdt.value)
    }

    // handlers for clicking one of the icons
    const onClickArchive = (userAction) => (event) => {
        event.stopPropagation()
        props.archiveUserAction(userAction)
    }
    const onClickFavorite = (userAction) => (event) => {
        event.stopPropagation()
        props.favoriteUserAction(userAction)
    }

    /* render helpers */
    const renderButton = ({ icon, onClick }) => (
        <Button className={classes.userActionItemButton} onClick={onClick} variant="subtle">
            <Icon icon={icon} className={classes.userActionItemButtonIcon} />
        </Button>
    )

    const renderItem = (userAction) => {
        const archiveButton = {
            icon: "times",
            onClick: onClickArchive(userAction),
        }
        const favoriteButton = {
            icon: "star",
            onClick: onClickFavorite(userAction),
        }

        return (
            <Paper
                className={`${classes.userActionItem} ${props.editing ? classes.notClickable : ""}`}
                onClick={!props.editing ? onClick(userAction) : undefined}
            >
                <Icon
                    className={classes.userActionItemIcon}
                    icon={DjangIO.app.models.QuorumDataType.by_value(userAction.data_type).fa5_icon}
                />
                <Text className={classes.userActionItemText} truncate={true}>
                    {userAction.humanized_text}
                </Text>
                <div className={classes.userActionItemButtonContainer}>
                    {(userAction.is_favorited ? [archiveButton] : [favoriteButton, archiveButton]).map(renderButton)}
                </div>
            </Paper>
        )
    }

    const renderList = (header = "", loadingText = "", items = [], noItemText = "") => (
        <Flex className={classes.userActionList} direction="column">
            <Text className={classes.userActionListHeader} weight={500}>
                {header}
            </Text>
            {props.isLoadingUserActions ? (
                <Flex className={`${classes.userActionContainer} ${classes.empty}`}>{loadingText}</Flex>
            ) : (
                <Flex
                    className={`${classes.userActionContainer} ${
                        props.recents.length || props.favorites.length ? "" : classes.empty
                    }`}
                    direction="column"
                    gap=".25rem"
                >
                    {items.length ? items.map(renderItem) : <Text>{noItemText}</Text>}
                </Flex>
            )}
        </Flex>
    )

    const renderFavorites = () =>
        renderList(
            constants.favoritesHeader,
            constants.favoritesLoadingText,
            props.favorites,
            constants.noFavoriteActions,
        )
    const renderHistory = () =>
        renderList(constants.recentsHeader, constants.recentsLoadingText, props.recents, constants.noRecentActions)

    return (
        <Flex
            className={`${classes.userActionWrapper} ${props.inWidget ? classes.userActionInWidget : ""}`}
            gap="1.5rem"
        >
            {!props.showOnlyRecents && renderFavorites()}
            {!props.showOnlyFavorites && renderHistory()}
        </Flex>
    )
}
